import React, { useState } from "react";
import { FaTimes, FaCheckCircle } from "react-icons/fa";
import {
  colors,
  spacing,
  radius,
  shadows,
  typography,
} from "../utils/designTokens";

/**
 * Banner de bienvenida que se muestra al residente la primera vez que entra
 * después de activar su cuenta. Bloque 7 del rediseño.
 *
 * Condicional: solo aparece si `isFirstLogin` (ver useUserProfile.js).
 * El usuario puede cerrarlo con la X (estado local, vuelve a aparecer
 * si recarga durante las primeras 24h).
 */
const FirstLoginBanner = ({ displayName }) => {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div
      style={{
        background: colors.primaryLighter,
        border: `1px solid ${colors.primaryLight}`,
        borderRadius: radius.md,
        padding: spacing[5],
        marginBottom: spacing[6],
        boxShadow: shadows.sm,
        display: "flex",
        gap: spacing[4],
        alignItems: "flex-start",
        position: "relative",
        fontFamily: typography.fontFamily,
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: radius.sm,
          background: colors.primary,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <FaCheckCircle style={{ fontSize: 18 }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <h2
          style={{
            margin: 0,
            fontSize: 16,
            fontWeight: 400,
            color: colors.black,
            marginBottom: spacing[1],
          }}
        >
          ¡Bienvenido a Habitia{displayName ? `, ${displayName}` : ""}!
        </h2>
        <p
          style={{
            margin: 0,
            fontSize: 13,
            color: colors.gray700,
            lineHeight: 1.5,
            marginBottom: spacing[3],
          }}
        >
          Acá vas a poder ver tus gastos comunes, reportar incidencias del
          edificio y leer las novedades de la administración. Cuando se generen,
          aparecen automáticamente en su sección correspondiente.
        </p>
        <ul
          style={{
            margin: 0,
            padding: 0,
            listStyle: "none",
            display: "grid",
            gap: spacing[2],
            fontSize: 12,
            color: colors.gray700,
          }}
        >
          <li>
            • Si reservás amenities (gimnasio, salón de fiestas), entrá a la
            sección <strong>Amenities</strong>.
          </li>
          <li>
            • Para reportar un problema del edificio o tu unidad, usá{" "}
            <strong>Incidencias</strong>.
          </li>
          <li>
            • Tus pagos y deudas con la administración los ves en{" "}
            <strong>Cuentas</strong>.
          </li>
        </ul>
      </div>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Cerrar banner de bienvenida"
        className="habitia-btn-ghost"
        style={{
          position: "absolute",
          top: spacing[3],
          right: spacing[3],
          background: "transparent",
          border: "none",
          padding: 6,
          borderRadius: radius.sm,
          color: colors.gray400,
          cursor: "pointer",
        }}
      >
        <FaTimes size={14} />
      </button>
    </div>
  );
};

export default FirstLoginBanner;
